import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { CopyGuidelineInfoDto } from '@treetop/shared/model';

@Injectable({ providedIn: 'root' })
export class AdminHttpService {
  private http = inject(HttpClient);
  private baseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/admin`;

  public copyGuideline(dto: CopyGuidelineInfoDto): Observable<{ Message: string }> {
    return this.http.post<{ Message: string }>(`${this.baseUrl}/copy-guideline`, dto);
  }
}
